import { domainStore } from '@/stores/DomainStore';
import { familyStore } from '@/stores/FamilyStore';
import { hybridPedigreeStore } from '@/stores/HybridPedigreeStore';
import { uiStore } from '@/stores/UIStore';
import { factTypesStore } from '@/stores/FactTypesStore';
import { personFactsStore } from '@/stores/PersonFactsStore';
import { personLifeEventsStore } from '@/stores/PersonLifeEventsStore';
import { activityStore } from '@/stores/ActivityStore';
import { personStoriesStore } from '@/stores/PersonStoriesStore';
import { familyStoriesStore } from '@/stores/FamilyStoriesStore';
import { mediaStore } from '@/stores/MediaStore';
import { gedcomExportStore } from '@/stores/GedcomExportStore';
import { suggestionsStore } from '@/stores/SuggestionsStore';
import { reviewQueueStore } from '@/stores/ReviewQueueStore';
import { memberAccessStore } from '@/stores/MemberAccessStore';
import { notificationPreferencesStore } from '@/stores/NotificationPreferencesStore';

/**
 * Store access hooks - Simple singleton access pattern
 * Following pantryPlus approach where stores are singleton exports
 */

export const useDomainStore = () => domainStore;
export const useFamilyStore = () => familyStore;
export const useHybridPedigreeStore = () => hybridPedigreeStore;
export const useUIStore = () => uiStore;
export const useFactTypesStore = () => factTypesStore;
export const usePersonFactsStore = () => personFactsStore;
export const usePersonLifeEventsStore = () => personLifeEventsStore;
export const useActivityStore = () => activityStore;
export const usePersonStoriesStore = () => personStoriesStore;
export const useFamilyStoriesStore = () => familyStoriesStore;
export const useMediaStore = () => mediaStore;
export const useGedcomExportStore = () => gedcomExportStore;
export const useSuggestionsStore = () => suggestionsStore;
export const useReviewQueueStore = () => reviewQueueStore;
export const useMemberAccessStore = () => memberAccessStore;
export const useNotificationPreferencesStore = () => notificationPreferencesStore;
